import classes from "./BoxTitle.module.css";

import Tooltip from "../../../layout/tooltip/Tooltip";
import { useStore } from "../../../hooks/store";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const defaultIcon = (
  <i
    className="im im-icon-Truck"
    style={{ color: "white", fontSize: "30px" }}
  />
);

const BoxTitle = ({
  className,
  styleIcon,
  icon,
  link,
  id,
  title,
  externalLink,
  internalLink,
  infoContext,
  element,
  isDailyAverage,
}) => {
  const dispatch = useStore(false)[1];
  const { t } = useTranslation();

  const tooltipId = `info-tooltip-${title}${isDailyAverage ? "_daily" : ""}`;

  const infoItem = () => {
    return (
      infoContext && (
        <span className={classes.triggerTooltip}>
          <button
            type="button"
            aria-label="More information"
            style={{
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              width: "24px",
              height: "24px",
              marginLeft: "4px",
            }}
          >
            <i
              className="fa fa-info-circle"
              style={{
                color: "white",
                // position: "absolute",
              }}
            />
          </button>
          <Tooltip id={tooltipId} tooltipContent={infoContext} />
        </span>
      )
    );
  };

  return (
    <div className={[classes.flexContainer, className].join(" ")}>
      {icon?.includes("svg") ? (
        <img
          width={id === "122" ? 30 : 50}
          style={{ color: "red" }}
          src={icon}
          alt=""
        />
      ) : (
        <i
          className={icon}
          aria-hidden="true"
          style={
            styleIcon
              ? { color: "white", fontSize: "30px", ...styleIcon }
              : { color: "white", fontSize: "30px" }
          }
        />
      )}

      {!icon && defaultIcon}

      <div className={classes.title}>
        {link && (
          <Link onClick={() => id && dispatch("CLICKED_TYPE", id)} to={link}>
            <span>{title}</span>
          </Link>
        )}
        {externalLink && (
          <a href={externalLink} target="_blank" rel="noreferrer">
            <span>{title}</span>
          </a>
        )}
        {internalLink && (
          <Link to={internalLink} rel="noreferrer">
            <span>{title}</span>
          </Link>
        )}

        {!link && !externalLink && !internalLink && <span>{title}</span>}

        {infoItem()}
      </div>
      <div
        // id="draggable"
        // aria-label="Drag to reorder widget"
        role="button"
        tabIndex={0}
        className={[
          classes.lastElementPlaceholder,
          classes.triggerTooltip,
        ].join(" ")}
      >
        {/* {element} */}
        <Tooltip
          id={`${tooltipId}_tooltip`}
          tooltipContent={t("Σύρετε από εδώ")}
          className={classes.dragAndDropTooltip}
        />
      </div>
    </div>
  );
};

export default BoxTitle;
